<template>
    <div class="analysisTable">
        <div class="analysisTable__header">
            <div class="analysisTable__header--icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="18" viewBox="0 0 23 18" fill="none">
  <path d="M21.6979 14.5332V6.5725M21.6979 14.5332C21.6979 15.4126 20.9851 16.1254 20.1057 16.1254H2.59214C1.71283 16.1254 1 15.4126 1 14.5332M21.6979 14.5332V2.59214M21.6979 6.5725H1M21.6979 6.5725V2.59214M1 6.5725V14.5332M1 6.5725V2.59214M1 14.5332V2.59214M21.6979 2.59214C21.6979 1.71283 20.9851 1 20.1057 1H2.59214C1.71283 1 1 1.71283 1 2.59214M15.3293 12.145H17.7175" stroke="#3682F3" stroke-width="2" stroke-linecap="round"/>
</svg>
            </div>
            <div class="analysisTable__header--title">Cartao de Credito</div>
        </div>
        <div class="analysisTable__content" v-if="!isLoading">
            <div class="analysisTable__content--list">
                <!-- <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Nome do titular</div>        //confirmar se vai manter ou excluir
                            <div class="item__container--value">{{ name }}</div>
                        </div>
                    </div>
                </div> -->
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Bandeira</div>
                            <div class="item__container--value">{{ brand }}</div>
                        </div>
                    </div>
                </div>
                <!-- <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Numero do Cartao</div>      //confirmar se vai manter ou excluir
                            <div class="item__container--value">{{ email }}</div>
                        </div>
                    </div>
                </div> -->
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Pais</div>
                            <div class="item__container--value">{{ country }}
                                <svg v-if="['brasil', 'br', 'brazil'].includes(country.toLowerCase())" 
                                xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 72 72"><path fill="#5c9e31" d="M5 17h62v38H5z"/><path fill="#fcea2b" d="m59.023 36.023l-23.157 14.63l-22.889-14.362l23.157-14.63z"/><circle cx="36" cy="36" r="9" fill="#1e50a0"/><path fill="#fff" d="M44.159 39.782a9 9 0 0 0 .696-2.26a11.474 11.474 0 0 0-17.477-4.04a9 9 0 0 0-.352 2.013a10.998 10.998 0 0 1 17.133 4.287"/><path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M5 17h62v38H5z"/></svg>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Empresarial</div>
                            <div class="item__container--value">{{ isBusiness }}</div>
                            
                        </div>
                    </div>
                </div>
                <!-- <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Organizao</div>         //confirmar se vai manter ou excluir
                            <div class="item__container--value">{{ cpf }}</div>
                            
                        </div>
                    </div>
                </div> -->
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Emitido no pais do end. de cobranca</div>
                            <div class="item__container--value">{{ isIssuedInBillingAddressCountry }}</div>
                            
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Pre-pago</div>
                            <div class="item__container--value">{{ isPrepaid }}</div>
                            
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Virtual</div>
                            <div class="item__container--value">{{ isVirtual }}</div>
                            
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Emissor</div>
                            <div class="item__container--value">{{ name }}</div>
                            
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item no-border">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Tipo</div>
                            <div class="item__container--value">{{ type }}</div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="row justify-content-center p-5">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: 'AnalysisTableClient',
    props: {
        data: {
            type: Object,
            required: true
        },
        totalizer: {
            type: Object,
            required: false
        },
    },
    computed: {
        isLoading() {
            return this.$store.getters["getLoadingAnalysis"]
        },
        brand() {
            return this.data && this.data.risk_body && this.data.risk_body.credit_card && this.data.risk_body.credit_card.brand ? this.data.risk_body.credit_card.brand : '---';
        },
        country() {
            return this.data && this.data.risk_body && this.data.risk_body.credit_card && this.data.risk_body.credit_card.country ? this.data.risk_body.credit_card.country : '---';
        },
        isBusiness() {
            return this.data && this.data.risk_body && this.data.risk_body.credit_card && this.data.risk_body.credit_card.is_business ? 'Sim' : 'Não';
        },
        isIssuedInBillingAddressCountry() {
            return this.data && this.data.risk_body && this.data.risk_body.credit_card && this.data.risk_body.credit_card.is_issued_in_billing_address_country ? 'Sim' : 'Não';
        },
        isPrepaid() {
            return this.data && this.data.risk_body && this.data.risk_body.credit_card && this.data.risk_body.credit_card.is_prepaid ? 'Sim' : 'Não';
        },
        isVirtual() {
            return this.data && this.data.risk_body && this.data.risk_body.credit_card && this.data.risk_body.credit_card.is_virtual ?  'Sim' : 'Não';
        },
        name() {
            return this.data && this.data.risk_body && this.data.risk_body.credit_card ? this.data.risk_body.credit_card.issuer.name : '---';
        },
        type() {
            return this.data && this.data.risk_body && this.data.risk_body.credit_card && this.data.risk_body.credit_card.type ? this.data.risk_body.credit_card.type : '---';
        },
    },
};
</script>

<style scoped lang="scss">
.analysisTable {
    width: 100%;
    margin: 20px 0px 0px 0px;

    &__header {
        padding: 0px 20px;
        display: flex;
        justify-content: flex-start;

        &--icon {
            width: 20.698px;
            height: 20.698px;
            flex-shrink: 0;
        }

        &--title {
            color: #3682F3;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            margin-left: 14px;
        }
    }

    &__content {
        height: auto;
        width: 100%;

        hr {
            background: #E5E5E5;
        }

        &--list {
            height: auto;
            width: 100%;
            margin: 20px 0px;

            .item {
                border-bottom: solid 1px #E5E5E5;
                position: relative;

                &__container {
                    padding: 20px;

                    &--title {
                        color: #B1B1B1;
                        font-size: 0.8em;
                        font-style: normal;
                        font-weight: 400;
                        line-height: normal;
                    }

                    &--value {
                        color: #141414;
                        font-size: 0.9em;
                        font-style: normal;
                        font-weight: 600;
                        line-height: normal;
                        width: calc(100% - 40px);
                        overflow-x: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }

                    &--pill {
                        position: absolute;
                        right: 20px;
                        top: 30%;
                        width: auto;
                        font-size: 0.7em;
                        padding: 4px 10px;
                        font-size: 12px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: normal;
                        border-radius: 50px;


                    }
                }

            }

            .no-border .item {
                border-bottom: none;
            }

        }
    }
}

.blue {
    background: rgba(54, 130, 243, 0.10);
    color: #3682F3;
}

.red {
    background: rgba(255, 95, 95, 0.10);
    color: #FF5F5F;
}
</style>